export const enum Breakpoints {
    TABLET = 768,  // UNDER THIS VALUE ARE THE MOBILE DEVICES
    LAPTOP = 992,
    WIDE_SCREEN = 1200
}